import React from 'react'
import { makeStyles } from '@material-ui/core'
import { Typography, Button } from 'foundations-library/components'
import { getValue } from 'firebase-utils'

const jss = () => ({
    campaignsLandingPage: {
        maxWidth: 500,
        margin: '0 auto'
    },
    imgContainer: {
        padding: '0 20px',
        marginBottom: 80
    },
    title: {
        marginBottom: 10
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 40
    }
})

const useStyles = makeStyles(jss)

interface PropsInterface {
    onClickAddNew(): unknown
}

/**
 *
 */
const LandingPage = ({ onClickAddNew }: PropsInterface): JSX.Element => {
    const styles = useStyles()
    return <div className={styles.campaignsLandingPage}>
        <div className={styles.imgContainer}>
            <img src="https://s3.us-west-2.amazonaws.com/assets.phone.com/sms-registration/campaings-landing-page.png" alt="campaings-landing-page" />
        </div>
        <Typography variant='h4' className={styles.title} align='center'>Start Campaign Registration</Typography>
        <Typography align='center'>Create and submit a campaign to enable compliant SMS messaging under an approved brand.</Typography>
        <div className={styles.buttonContainer}>
            <Button icon='add' iconLeft onClick={onClickAddNew} className={styles.addButton}>
                {getValue('sms_enrollment_add_new_campaign')}
            </Button>
        </div>
    </div>
}

export default LandingPage
